// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3TTPe","label":"Labeled_label__2l07-","divider":"Labeled_divider__1cjLa"};